<template>
    <v-app>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Login</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form>
                                <v-text-field prepend-icon="person" name="username" label="username" type="text"
                                    v-model="username"></v-text-field>
                                <v-text-field prepend-icon="lock" name="password" label="password" type="password"
                                    v-model="password"></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" v-on:click="login">login</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!--- Snackbars -->
        <v-snackbar v-model="snackbarError" :right="true">
            Username or password is missing.
            <v-btn color="pink" flat @click="snackbarError = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbarConnectionError" :right="true">
            Can't etablish connection.
            <v-btn color="pink" flat @click="snackbarConnectionError = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-snackbar v-model="snackbarWrongCredentials" :right="true">
            Username or password is wrong.
            <v-btn color="pink" flat @click="snackbarWrongCredentials = false">
                Close
            </v-btn>
        </v-snackbar>
        <v-snackbar v-model="cookies" :timeout="null">
            This side is using cookies for authentication.
        </v-snackbar>
    </v-app>
</template>

<script>
    import axios from 'axios';
    axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

    export default {
        name: "Login",
        data() {
            return {
                username: "",
                password: "",
                cookies: true,
                snackbarError: false,
                snackbarConnectionError: false,
                snackbarWrongCredentials: false
            }
        },
        methods: {
            login() {
                if (this.password == "" || this.username == "") {
                    this.snackbarError = true;
                } else {
                    axios.post('/sign_in_admin', {
                            name: this.username,
                            pw: this.password
                        })
                        .then(response => {
                            if (response.data.status == true) {
                                localStorage.setItem("isLogedIn", true)
                                this.$router.push('/')
                            } else {
                                this.snackbarWrongCredentials = true;
                            }
                        })
                        .catch(error => {
                            this.snackbarConnectionError = true;
                        });
                }
            }
        }
    }
</script>